import { useEffect } from "react";
import { Hero } from "../components/sections/Hero";
import { About } from "../components/sections/About";
import { PathChooser } from "../components/sections/PathChooser";
import { Contact } from "../components/sections/Contact";

export default function HomePage() {
  useEffect(() => {
    document.title = "REYCRO — Athlete & Music Producer";
  }, []);

  return (
    <>
      <Hero />
      <About />
      <PathChooser />
      <Contact />
    </>
  );
}
